module.exports = __webpack_public_path__ + "img/upload.14dd1331.svg";